
const newModel = () => {
    return {
        trinhdochuyenmonYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        trinhdochuyenmonYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        trinhdochuyenmonYId: item.trinhdochuyenmonYId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        trinhdochuyenmonYId: item.trinhdochuyenmonYId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        trinhdochuyenmonCosoduocId: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        trinhdochuyenmonCosoduocId: item.trinhdochuyenmonCosoduocId,
        ten: item.ten,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        trinhdochuyenmonYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const trinhdochuyenmonYModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


